import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import DeleteAccount from "./pages/DeleteAccount";
import TNCModal from "./components/Modals/TNCModal";
import TnC from "./pages/Tnc";
import Privacy from "./pages/privacy";
import Subs from "./pages/subscription";
import HelpDocs from "./pages/HelpDocs";
import Account from "./pages/Account";
import InvoiceRedirect from "./pages/InvoiceRedirect";
import ViewRedirect from "./pages/ViewRedirect";
import Referral from "./pages/Referral";
import ResetPin from "./pages/ResetPin";
import Unsubscribe from "./pages/Unsubscribe";
import Products from "./pages/Products";
import { AuthProvider } from "./auth/AuthContext";

export default function App() {
  return (
    <>
      <AuthProvider>
        <Router>
          <Routes>
            <Route path="/delete-account" element={<DeleteAccount />} />
            <Route path="/" element={<Home />} />
            <Route path="/tnc" element={<TnC />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/subscriptions" element={<Subs />} />
            <Route path="/docs" element={<HelpDocs />} />
            <Route path="/account" element={<Account />} />
            {/* Where an emailed PIN-reset link lands. {guid} is the link's
                credential; ?uid= is the base64url owner token, used verbatim. */}
            <Route path="/account/resetpin/:guid" element={<ResetPin />} />
            {/* Where the unsubscribe link in a campaign mail's footer lands.
                One hardcoded URL for every recipient (see the ses-templates
                README), so the page asks for the address rather than reading it
                from the link. Public and signed-out, like the reset-pin route.
                Must stay in sync with that footer's href. */}
            <Route path="/account/unsubscribe" element={<Unsubscribe />} />
            {/* The old address a texted invoice link lands on when the recipient
                has no app. It no longer draws the document — the web app does,
                at /view?guid= — and forwards there. Kept so the links already
                in people's messages still open, and because the Android App
                Links pathPrefix still names this path. */}
            <Route path="/invoice/:invoiceId" element={<InvoiceRedirect />} />
            {/* The web app's viewer path, forwarded with its query intact. Only
                reached if a share link was minted against this host — the
                service's own base URL is the web app — but a blank page is a
                poor way to discover that. */}
            <Route path="/view" element={<ViewRedirect />} />
            {/* Where a shared referral message lands. Public and signed-out,
                like the invoice route; the code in the path is the credential.
                Not claimed by either app's link filters — the recipient needs
                this page, not the app, until they decide to install. */}
            <Route path="/r/:code" element={<Referral />} />
            {/* E8 Signage catalogue. Deliberately unlinked: /products is the
                only way in, so it stays off the home page's nav and CTAs. */}
            <Route path="/products" element={<Products />} />
          </Routes>
        </Router>
      </AuthProvider>
    </>
  );
}
